module.exports = __webpack_public_path__ + "img/06-เปลี่ยนแปลงแก้ไขที่อยู่.99447a6c.png";